import React from 'react'
import { useActions, useValues } from 'kea'
import Modal from 'react-responsive-modal'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import redirect from 'lib/utils/redirect-url'

import PhonePopUp from '~/scenes/popups/phone'

import sceneLogic from '../logic'

const Phone = ({ lastOnRight }) => {
  const { openModal } = useActions(sceneLogic)
  const { isOpenModal, isSmallScreen } = useValues(sceneLogic)

  const lastOnRightClass = lastOnRight ? ' ml-auto' : ''

  const handlePhoneClick = event => {
    event.preventDefault()
    event.stopPropagation()

    if (!isSmallScreen) {
      openModal()
    } else {
      redirect('/popups/phone')
    }
  }

  return (
    <>
      <div className={`item phone${lastOnRightClass}`}>
        <a href='/popups/phone' onClick={handlePhoneClick} aria-label={I18n.t('pages.contact.contact')} />
      </div>
      <Modal
        onOverlayClick={() => {
          openModal()
        }}
        showCloseIcon={false}
        open={isOpenModal}
        onClose={() => {}}
        center
      >
        <PhonePopUp />
      </Modal>
    </>
  )
}

Phone.propTypes = {
  lastOnRight: PropTypes.bool
}

export default Phone
